import React from 'react';

import { View, StyleSheet } from 'react-native';
import Colors from "../../constants/Colors";
import {ButtonImageWithText, Card, Header} from "../../components";
import NavBar from "../../components/NavBar";

class DeliveryHub extends React.Component {

    render() {
        return (
            <NavBar title={"Colocar em Prática"}>

                <View style={{ width: 400 }}>
                    <Card containerStyle={{ height: 170, margin: 20, padding: 18 }}>

                        <Header text={"Bar Aberto e Protegido"} propsTextStyle={{ fontSize: 22 }} />

                        <ButtonImageWithText
                            text={"Bar Aberto e Protegido"}
                            onPress={() => this.props.history.push('/applications/userApplications')}
                            imageSrc={require('../../imageImports/userDeliveryCard.png')}
                            propsContainerStyle={styles.buttonContainerStyle}
                            propsImageStyle={styles.imageStyle}
                            propsTextStyle={styles.textStyle}
                        />

                    </Card>

                    <Card containerStyle={{ height: 170, margin: 20, padding: 18 }}>

                        <Header text={"Avaliar Colegas"} propsTextStyle={{ fontSize: 22 }} />

                        <ButtonImageWithText
                            text={"Avaliar Colegas"}
                            onPress={() => this.props.history.push('/applications/journeys')}
                            imageSrc={require('../../imageImports/userReviewCard.png')}
                            propsContainerStyle={styles.buttonContainerStyle}
                            propsImageStyle={styles.imageStyle}
                            propsTextStyle={styles.textStyle}
                        />

                    </Card>
                </View>

            </NavBar>
        )
    }
}

const styles = StyleSheet.create({
    buttonContainerStyle: {
        height: 120,
        width: '96%',
        flexDirection: 'column',
        backgroundColor: Colors.cardButtonBackground,
        borderRadius: 8,
        margin: 8
    },
    imageStyle: {
        marginLeft: 0,
        marginRight: 0,
        marginTop: 0,
        marginBottom: 0,
        width: '100%',
        height: '85%',
        borderRadius: 4
    },
    textStyle: {
        color: Colors.cardButtonFontColor
    }
})

export default DeliveryHub;
